export const environment = {
    urls: {
        api: 'https://52sdkha8y7.execute-api.eu-central-1.amazonaws.com/dev/',
    },
        push: {
        subject: "",
        publicKey: "",
        privateKey: "",
        api: "",
    },
    okta: {
        issuer: 'https://jabildev.oktapreview.com',
        clientId: '0oa2iqat867RrqNHY0h8',
        redirectUri:'https://dev.offlineprocess.jabilapps.com/login/callback',
        scopes: ['openid', 'email', 'profile'],
        pkce: true
    }
};
